import { Button } from 'appkit-react';

import '../styles/signupSuccess.scss';

const SignupSuccess = ({ onLogin }) => (
    <div className="true-comply-signup-success-container">
        <div
            className="success-title"
        >
            <span>Success!</span>
        </div>
        <div className="content">
            <p>
                Your account has been created successfully.
                <br />
                Please sign in now.
            </p>
        </div>
        <div className="action">
            <Button size="lg" kind="primary" onClick={onLogin}>
                SIGN IN
            </Button>
        </div>
    </div>
);

export default SignupSuccess;
